function stage_language() {
  return window?.stage_language || document?.documentElement?.lang || 'fi';
}

export default stage_language();
